import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function fileUrl(fileId) {
  if (!fileId) return null;
  return `${API}/files/${fileId}`;
}
